const LIMITE_DIAS_DETALHADO = 3;

function pluralizar(valor, singular, plural) {
  return valor === 1 ? singular : plural;
}

// Texto da contagem regressiva, com granularidade que diminui conforme o
// tempo restante cresce — mostrar segundos ticando quando ainda faltam 3+
// dias é ruído puro, sem nenhum ganho de informação real pra quem está
// lendo. Abaixo de LIMITE_DIAS_DETALHADO dias já mostra tudo (dias, horas,
// minutos, segundos) — é a reta final de verdade, cada unidade importa.
export function formatarContagem(restante) {
  if (!restante || restante.encerrou) return null;
  const { dias, horas, minutos, segundos } = restante;

  if (dias >= LIMITE_DIAS_DETALHADO) {
    const partes = [`${dias} ${pluralizar(dias, 'dia', 'dias')}`];
    if (horas > 0) partes.push(`${horas} ${pluralizar(horas, 'hora', 'horas')}`);
    return `${dias === 1 ? 'Falta' : 'Faltam'} ${partes.join(' e ')}`;
  }

  if (dias >= 1) {
    const partes = [
      `${dias} ${pluralizar(dias, 'dia', 'dias')}`,
      `${horas} ${pluralizar(horas, 'hora', 'horas')}`,
      `${minutos} ${pluralizar(minutos, 'minuto', 'minutos')}`,
      `${segundos} ${pluralizar(segundos, 'segundo', 'segundos')}`
    ];
    return `${dias === 1 ? 'Falta' : 'Faltam'} ${partes.join(' ')}`;
  }

  if (horas >= 1) {
    const partes = [`${horas} ${pluralizar(horas, 'hora', 'horas')}`];
    if (minutos > 0 || segundos > 0) partes.push(`${minutos} ${pluralizar(minutos, 'minuto', 'minutos')}`);
    if (segundos > 0) partes.push(`${segundos} ${pluralizar(segundos, 'segundo', 'segundos')}`);
    const verbo = horas === 1 && partes.length === 1 ? 'Falta' : 'Faltam';
    return `${verbo} ${juntarComE(partes)}`;
  }

  if (minutos >= 1) {
    const partes = [`${minutos} ${pluralizar(minutos, 'minuto', 'minutos')}`];
    if (segundos > 0) partes.push(`${segundos} ${pluralizar(segundos, 'segundo', 'segundos')}`);
    const verbo = minutos === 1 && partes.length === 1 ? 'Falta' : 'Faltam';
    return `${verbo} ${juntarComE(partes)}`;
  }

  return `${segundos === 1 ? 'Falta' : 'Faltam'} ${segundos} ${pluralizar(segundos, 'segundo', 'segundos')}`;
}

function juntarComE(partes) {
  if (partes.length <= 1) return partes.join('');
  return `${partes.slice(0, -1).join(' ')} e ${partes[partes.length - 1]}`;
}

// Nível de urgência — só decide cor/estilo da faixa em CompartilharEnquete.js,
// nunca o texto (isso é sempre formatarContagem acima). 'critico' (< 1
// minuto) é o único que pulsa visualmente — 'urgente' (minutos) já dura até
// quase 1h, pulsar o tempo todo nesse intervalo seria irritante, não útil.
export function nivelUrgencia(restante) {
  if (!restante || restante.encerrou) return null;
  if (restante.dias >= 1) return 'calmo';
  if (restante.horas >= 1) return 'atencao';
  if (restante.minutos >= 1) return 'urgente';
  return 'critico';
}
